<template>
  <div>
    <div v-if="!app.balanceCad || data.category =='REGULARIZATION'">
      <zul-button class="is-view">
        <span slot="icon" class="icon is-cad"></span>
        <span class="sub">R$ </span> <strong>{{ data.product.total | currency('', 2,  { decimalSeparator:',' }) }}</strong>
        <span slot="sub"></span>
      </zul-button>
    </div>
    <div v-else-if="data.product">
      <zul-button class="is-view">
        <span slot="icon" class="icon is-cad"></span>
        <template v-if="data.product.cads">{{ data.product.cads }} {{ data.product.cads | pluralize('Cartão', 'Cartões') }}</template>
        <span slot="sub"><span class="sub">R$ </span> <strong>{{ data.product.total | currency('', 2,  { decimalSeparator:',' }) }}</strong></span>
      </zul-button>
    </div>

    <input ref="number" class="bankslip-number" :value="data.documentNumber" disabled>

    <ul class="bankslip-actions">
      <li><a href="#" class="bankslip-action is-copy" @click="copy">Copiar</a></li>
      <li><a href="#" class="bankslip-action is-download" @click="window.open(data.paymentUrl, '_blank')">Baixar</a></li>
      <li><a href="#" class="bankslip-action is-cancel" @click="cancel">Cancelar</a></li>
    </ul>

    <div class="warning">
      <h3 class="title">{{$t('bankslip.warning.title')}}</h3>
      <p v-if="data.category =='REGULARIZATION'">{{$t('bankslip.warning.message')}}</p>
      <p v-else>{{$t('bankslip.warning.message2')}}</p>
    </div>
  </div>
</template>

<script>
import ZulButton from './Button.vue'

export default {
  props: {
    data: Object
  },
  created () {
    this.window = window
  },
  methods: {
    copy () {
      this.$refs.number.value = this.data.documentNumber

      this.$refs.number.disabled = false
      this.$refs.number.select()
      this.$refs.number.disabled = true
      
      const result = document.execCommand("copy")

      if (result) {
        this.$refs.number.classList.add('is-done')
        this.$refs.number.value = this.$t('bankslip.barcodeInstruction')
      }
    },

    cancel () {
      this.$root.$emit('cancel-bankslip-start')

      if (this.data.category =='REGULARIZATION') {
        this.REGULARIZATION.delete(`/regularization/order/${this.data.id}`)
          .then(() => {
            this.$root.$emit('cancel-bankslip-end')
          })
      } else {
        this.$http.put(`/order/${this.data.id}/cancel`)
          .then(() => {
            this.$root.$emit('cancel-bankslip-end')
          })
      }
    }
  },
  components: {
    ZulButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';
  .is-view {
    margin: 0;
  }
  
  .bankslip-number {
    display: block;
    padding: .75rem;
    font-size: $size-6;
    background: $white;
    color: $black;
    width: 100%;
    text-align: center;

    border: none;
    outline: none;
    box-shadow: none;

    &.is-done {
      //background-color: $primary;
      color: $white;

      @each $city, $map in $cities {
        .is-#{$city} & {
          background-color: map-get($map, 'primary');
        }            
      }
    }
  }

  .bankslip-actions {
    background-color: $black;
    display: flex;
    justify-content: space-around;

    .bankslip-action {
      color: $white;
      padding: 3.25rem 2rem 1.25rem;
      display: block;
      font-size: .9rem;
      background: $black no-repeat center 1.25rem;
      opacity: .65;
      transition: .2s all;

      transition: .2s background-color;

      &:hover {
        opacity: 1;
      }

      &.is-copy { background-image: $copyIcon; }
      &.is-download { background-image: $downloadIcon; }
      &.is-cancel { background-image: $cancelIcon; }
    }
  }

  .warning {
    padding: 2.5rem 4rem 0;
    font-size: $size-7;
    text-align: center;

    .title {
      font-size: $size-6;
      text-transform: uppercase;
      color: $white;
      margin: 0 0 .5rem;
    }
  }
  
</style>
